document.addEventListener('rebuy:cart.change', (event) => {
  const { cart } = event.detail.cart;
  const cart_items = cart.items;
  var cart_update = {};

  cart_items.forEach(item => {
    let offer_quantity = item.quantity;
    let offer_var_id = item.id;
    if('_offer_id' in item.properties) {
      let offer_id = item.properties._offer_id;
      let remove_offer = true;
      cart_items.forEach(main_item => {
        if(!('_offer_id' in main_item.properties)) {
          if(main_item.id == offer_id && main_item.quantity != offer_quantity) {
            cart_update[offer_var_id] = main_item.quantity;
          }
          if(main_item.id == offer_id) {
            remove_offer = false;
          }
        }
      });
      if(remove_offer) cart_update[offer_var_id] = 0;
    }
  });
    console.log("cart_update", cart_update)
  if(Object.keys(cart_update).length > 0) {
    for(id in cart_update) {
      console.log("scart_update",id,cart_update[id])
      window.Rebuy.Cart.changeItem({
        'id': id,
        'quantity': cart_update[id]
      });
    }
  }
});